import { render, staticRenderFns } from "./ConsolidatedFeesReceipt.vue?vue&type=template&id=104ecf2c&scoped=true&lang=html"
import script from "./ConsolidatedFeesReceipt.vue?vue&type=script&lang=js"
export * from "./ConsolidatedFeesReceipt.vue?vue&type=script&lang=js"
import style0 from "./ConsolidatedFeesReceipt.vue?vue&type=style&index=0&id=104ecf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104ecf2c",
  null
  
)

export default component.exports